module.exports = __webpack_public_path__ + "static/media/facial-confirm-register.8e17802e.svg";